// eslint-disable-next-line no-restricted-imports
import $ from 'jquery';
import window from 'window-or-global';
import { getOverride } from '@confluence/meta';

const template = (translate, versionComment) => `
<span class="rte-toolbar-comment toolbar-item">
    <input id="versionComment" name="versionComment" ${
			versionComment ? `value="${versionComment}"` : ''
		}
           placeholder="${translate('editor.change.comment')}"
           class="text" type="text" size="35">
    <label for="versionComment" class="assistive">${translate('editor.change.comment')}</label>
</span>
`;

const versionComment = () => {
	return {
		init(ed) {
			ed.on('Init', () => {
				const versionComment = getOverride('version-comment');
				$('#rte-savebar-tinymce-plugin-point').append(
					template((s) => ed.translate(s), versionComment),
				);
			});
		},

		getInfo() {
			return {
				longname: 'Confluence Version Comment',
				author: 'Atlassian',
				authorurl: 'http://www.atlassian.com',
				version: `${window.tinymce.majorVersion}.${window.tinymce.minorVersion}`,
			};
		},
	};
};

export default function () {
	window.tinymce.create('tinymce.plugins.ConfluenceVersionComment', versionComment());
	window.tinymce.PluginManager.add(
		'confluenceversioncomment',
		window.tinymce.plugins.ConfluenceVersionComment,
	);
}
